export default __webpack_public_path__ + "static/media/BuildBook.04d3e86e.jpg";